import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ConverterService, OccEndpointsService } from '@spartacus/core'
import {
  MB_PRODUCT_TAB_RESOURCES_NORMALIZER,
  MbProductTabResourcesAdapter
} from '../connectors/resources'

@Injectable({
  providedIn: 'root'
})
export class MbOccProductTabResourcesAdapter implements MbProductTabResourcesAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService) {
  }

  load (productCode: string, maxCount?: number) {
    return this.http.get(this.getEndpoint(productCode, maxCount)).pipe(this.converter.pipeable(MB_PRODUCT_TAB_RESOURCES_NORMALIZER))
  }

  protected getEndpoint (code: string, maxCount?: number) {
    return this.occEndpoints.buildUrl(
      'productTabResources',
      {
        urlParams: { productCode: code },
        queryParams: { maxCount },
      }
    )
  }
}
